import { createContext, useContext } from "react";
import { AuthResponse } from "@/shared/types/auth";
import { UserGetDTO } from "@/shared/types/shared/me";

export type AuthContextType = {
    isAuthenticated: boolean;
    loading: boolean;
    userPermissions: string[];
    userRoles: string[];
    signIn: (data: AuthResponse) => void;
    signOut: () => void;
    checkPermission: (permission: string) => boolean;
    user: AuthResponse | null;
    avatarUrl: string;
    userProfile: UserGetDTO | null;
    updateUserProfile: () => Promise<void>;
    /** Sessão de suporte da equipa 7Days: só leitura, sem refresh. */
    isSupportSession: boolean;
    /** Claim `platformAdmin` do token: abre o painel da plataforma. Nunca numa sessão de suporte. */
    isPlatformAdmin: boolean;
};

// Só o contrato vive aqui: entities/session/model/AuthProvider é quem o preenche.
export const authContext = createContext<AuthContextType>({} as AuthContextType);

export const useAuth = () => useContext(authContext);
